import {AUTH_CREDENTIALS_NAME} from "./../Constantes";

export const getCabecera = () =>{
    let Token = localStorage.getItem(AUTH_CREDENTIALS_NAME);
    let cabecera = { Authorization: `bearer ${Token}`,
    "Content-Type": "application/json",
    Accept: "application/json",}
    return cabecera;
}
